/** Custom column configuration */
export interface UserColumn {
  id: string;
  userId: string;
  name: string;
  color: string | null;
  position: number;
  isVisible: boolean;
  filters: ColumnFilters;
  sortBy: 'date' | 'sender' | 'subject';
  sortDirection: 'asc' | 'desc';
  createdAt: number;
  updatedAt: number;
}

/** Filter configuration for a column */
export interface ColumnFilters {
  logic: 'AND' | 'OR';
  rules: FilterRule[];
}

/** Individual filter rule */
export interface FilterRule {
  type: FilterRuleType;
  operator: FilterOperator;
  value: string | string[] | boolean;
}

/** Available filter rule types */
export type FilterRuleType =
  | 'label'
  | 'sender'
  | 'domain'
  | 'keyword'
  | 'priority'
  | 'hasAttachments'
  | 'isUnread'
  | 'hasThread'
  | 'category'
  | 'receivedWithin'
  | 'recipient'; // Email alias (e.g., jobs@boxento.com)

/** Available filter operators */
export type FilterOperator = 'is' | 'isNot' | 'contains';

/** Input for creating a new column */
export interface CreateColumnInput {
  name: string;
  color?: string;
  filters: ColumnFilters;
  sortBy?: 'date' | 'sender' | 'subject';
  sortDirection?: 'asc' | 'desc';
}

/** Input for updating a column */
export interface UpdateColumnInput {
  name?: string;
  color?: string | null;
  isVisible?: boolean;
  filters?: ColumnFilters;
  sortBy?: 'date' | 'sender' | 'subject';
  sortDirection?: 'asc' | 'desc';
}

/** Predefined column colors */
export const COLUMN_COLORS = [
  { name: 'Blue', value: '#3b82f6' },
  { name: 'Green', value: '#22c55e' },
  { name: 'Yellow', value: '#eab308' },
  { name: 'Orange', value: '#f97316' },
  { name: 'Red', value: '#ef4444' },
  { name: 'Purple', value: '#a855f7' },
  { name: 'Pink', value: '#ec4899' },
  { name: 'Teal', value: '#14b8a6' },
] as const;

/** Available labels for filtering */
export const LABEL_OPTIONS = [
  'Newsletter',
  'Promotions',
  'Social',
  'Updates',
  'Finance',
  'Travel',
  'Shipping',
  'Work',
  'Personal',
  'Receipts',
  'Reservations',
  'Purchases',
  'Billing',
  'Security',
  'Account',
  'Notifications',
  'Forums',
  'Marketing',
  'Legal',
  'Health',
] as const;

/** Available priority values for filtering */
export const PRIORITY_OPTIONS = ['important', 'normal', 'low'] as const;

/** Available category values for filtering */
export const CATEGORY_OPTIONS = ['do_nothing', 'delete', 'archive', 'unsubscribe'] as const;
